export const PANEL_ADMIN_EMAIL = 'admin@fidusfinance.com';
export const PANEL_ACCESS_DENIED = 'You are not authorized to access.';

const BROWSER_KEYS = ['access_token', 'role', 'fiddux_info'];

export function isPanelAdminRecord(email, role) {
  const normalized = String(email || '').trim().toLowerCase();
  return normalized === PANEL_ADMIN_EMAIL && role === 0;
}

export function shouldSendLoginAlert(source) {
  return source === 'submit';
}

export function googleProviderParameters() {
  return {
    hd: 'fidusfinance.com',
    login_hint: PANEL_ADMIN_EMAIL,
    prompt: 'select_account',
  };
}

export function googleSignInMessage(code) {
  switch (code) {
    case 'auth/popup-blocked':
      return 'Allow popups for this site and try again.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return 'Google sign-in was closed.';
    case 'auth/account-exists-with-different-credential':
      return 'Sign in with the admin password, then use Vincular Google.';
    case 'auth/unauthorized-domain':
      return 'This site is not authorized for Google sign-in.';
    default:
      return '';
  }
}

export function userHasGoogleProvider(user) {
  const list = (user && user.providerData) || [];
  return list.some((item) => item && item.providerId === 'google.com');
}

export function shouldShowLinkGoogleCard(user) {
  return Boolean(user) && !userHasGoogleProvider(user);
}

export async function finishPanelSignIn({ user, evaluate, accept, reject }) {
  const decision = await evaluate(user);
  if (!decision || decision.status !== 'ok') {
    await reject();
    return { status: 'denied', alerted: false };
  }
  await accept(user);
  return { status: 'ok', alerted: true, uid: user.uid };
}

export function linkedAccount(beforeUid, afterUser) {
  if (!beforeUid || !afterUser || afterUser.uid !== beforeUid) {
    return { ok: false, uid: afterUser && afterUser.uid ? afterUser.uid : '' };
  }
  return { ok: true, uid: afterUser.uid };
}

export function clearPanelBrowserKeys(storage) {
  if (!storage) return;
  BROWSER_KEYS.forEach((key) => storage.removeItem(key));
}

export function rememberPanelBrowserKeys(storage, user) {
  if (!storage || !user) return;
  storage.setItem(
    'fiddux_info',
    JSON.stringify({
      uid: user.uid,
      email: user.email || '',
    })
  );
  storage.removeItem('access_token');
  storage.removeItem('role');
}

export async function resolvePanelAccess({ user, getIdTokenResult, readUser }) {
  if (!user || !user.uid) return { status: 'signed-out' };

  let email = '';
  try {
    const token = await getIdTokenResult(true);
    email = (token && token.claims && token.claims.email) || user.email || '';
  } catch (_err) {
    return { status: 'denied' };
  }

  let snap;
  try {
    snap = await readUser(user.uid);
  } catch (_err) {
    return { status: 'denied' };
  }

  const exists = typeof snap.exists === 'function' ? snap.exists() : Boolean(snap.exists);
  const data = typeof snap.data === 'function' ? snap.data() : snap.data;
  if (!exists || !isPanelAdminRecord(email, data && data.role)) {
    return { status: 'denied' };
  }

  return { status: 'ok', email: String(email).trim().toLowerCase() };
}
